define('v3/Pages/WayOfWork/Components/WowDropdown/WowDropdown.Component',[
	'knockout',
	'v3/Common/Models/enums',
	'v3/Pages/WayOfWork/Services/WayOfWork.Service',
	'text!v3/Pages/WayOfWork/Components/WowDropdown/WowDropdown.Component.html'
], function (ko, enums, wayOfWorkService, htmlString) {
	function validateParams (params) {
		if (!ko.isWritableObservable(params.subjectCategory)) {
			throw new Error('params.subjectCategory is not observable.');
		}
	}

	function WowDropdownViewModel (params) {
		var self = this;
		validateParams(params);

		self.subjectCategory = params.subjectCategory;

		self.subjectCategoryLocalizedName = function (subjectCategoryValue) {
			return enums.subjectCategoryValue.getLocalizedName(subjectCategoryValue);
		};

		self.availableSubjectCategories = ko.observableArray();

		wayOfWorkService.getAvailableSubjectCategories().done(function (availableSubjectCategories) {
			if (availableSubjectCategories && availableSubjectCategories.length > 0) {
				self.availableSubjectCategories(availableSubjectCategories);
			}
		});
	}

	return { viewModel: WowDropdownViewModel, template: htmlString };
});
